import React from 'react';
import { TextBlock } from 'common/ui/TextBlock';

interface SourcingExternalTextBlockProps {
  title: string;
  items: (string | null)[];
}

export const SourcingExternalTextBlock: React.FC<
  SourcingExternalTextBlockProps
> = ({ title, items }) => {
  const filteredItems =
    items?.filter((item): item is string => item !== null) || [];

  if (filteredItems.length === 0) {
    return null;
  }

  return (
    <TextBlock
      variant="subhead"
      title={title}
      subtitle={
        <>
          {filteredItems.map((item, i) => (
            <li key={i} style={{ marginLeft: '14px' }}>
              {item}
            </li>
          ))}
        </>
      }
    />
  );
};
